import { View, html } from 'rune-ts';
import klass from './CreatorApplicationSection1.module.scss';
import { font } from '@services/MarppleShop/shared/typography';
import { ChevronRightIcon } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import { makeUtilScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr';

export class CreatorApplicationSection1 extends View<{ is_mobile: boolean }> {
  protected override template() {
    if (this.data.is_mobile) {
      return html`
        <section class="${klass.section}">
          <div class="${klass.section1}">
            <video
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              src="//s3.marpple.co/files/u_29089/2025/9/original/26a278e54aff42c4aa39717bf2589101f52fef071.mp4"
            ></video>
            <div class="${klass.dimmed}"></div>
            <div class="${klass.banner}">
              <div class="${klass.title}">
                <h1 class="${font('24_bold')}">
                  굿즈제작/판매부터<br />크리에이터 커머스까지,<br />마플샵에서 수익화하세요.
                </h1>
              </div>
              <div class="${klass.containers}">
                <div class="${klass.container}">
                  <a
                    href="/${ET.lang}/@/hello_creator"
                    data-post-message="${dataStr(makeUtilScreenNavigate(`/${ET.lang}/@/hello_creator`))}"
                    class="${klass.title_container} ${font('14_bold')}"
                    >크리에이터 ${ChevronRightIcon}</a
                  >
                  <div class="${klass.description_container} ${font('20_bold')}">
                    ${html.preventEscape(`나만의 아이디어를 가진<br />크리에이터 혹은 개인 사업자예요`)}
                  </div>
                  <a
                    href="/${ET.lang}/@/advance_reservation"
                    data-post-message="${dataStr(
                      makeUtilScreenNavigate(`/${ET.lang}/@/advance_reservation`),
                    )}"
                    class="${klass.button_container} ${font('16_bold')}"
                    >크리에이터 신청하기</a
                  >
                </div>
                <div class="${klass.container}">
                  <a
                    href="/${ET.lang}/@/plus"
                    class="${klass.title_container} ${font('14_bold')}"
                    data-post-message="${dataStr(makeUtilScreenNavigate(`/${ET.lang}/@/plus`))}"
                    >플러스샵 ${ChevronRightIcon}</a
                  >
                  <div class="${klass.description_container} ${font('20_bold')}">
                    ${html.preventEscape(`여러 개의 IP와 콘텐츠를<br />운영하는 기업이에요`)}
                  </div>
                  <a
                    href="/${ET.lang}/@/plus"
                    class="${klass.button_container} ${font('16_bold')}"
                    data-post-message="${dataStr(makeUtilScreenNavigate(`/${ET.lang}/@/plus`))}"
                    >플러스샵 신청하기</a
                  >
                </div>
              </div>
            </div>
          </div>
        </section>
      `;
    }

    const title = html.preventEscape(`크리에이터와 기업을 위한<br />올인원 커머스, 마플샵`);
    return html`
      <section class="${klass.section}">
        <div class="${klass.section1}">
          <div class="${klass.banner}">
            <video
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              class="${klass.motion_video}"
              src="//s3.marpple.co/files/u_29089/2025/9/original/26a278e54aff42c4aa39717bf2589101f52fef071.mp4"
            ></video>
            <div class="${klass.dimmed}"></div>
            <div class="${klass.container} ${klass.creator_container}">
              <a href="/${ET.lang}/@/hello_creator" class="${klass.title_container} ${font('14_bold')}"
                >크리에이터 ${ChevronRightIcon}</a
              >
              <div class="${klass.description_container} ${font('28_bold')}">
                ${html.preventEscape(`나만의 아이디어를 가진<br />크리에이터 혹은 개인 사업자예요`)}
              </div>
              <a href="/${ET.lang}/@/advance_reservation" class="${klass.button_container} ${font('20_bold')}"
                >마플샵 크리에이터 신청하기</a
              >
            </div>
          </div>
          <div class="${klass.banner}">
            <img
              src="//s3.marpple.co/files/u_29089/2025/9/original/afc512d69d3fa312c4d0ea713b3c3bc3a9b2c4e41.png"
              alt=""
            />
            <div class="${klass.dimmed}"></div>
            <div class="${klass.container} ${klass.plus_container}">
              <a href="/${ET.lang}/@/plus" class="${klass.title_container} ${font('14_bold')}"
                >플러스샵 ${ChevronRightIcon}</a
              >
              <div class="${klass.description_container} ${font('28_bold')}">
                ${html.preventEscape(`여러 개의 IP와 콘텐츠를<br />운영하는 기업이에요`)}
              </div>
              <a href="/${ET.lang}/@/plus" class="${klass.button_container} ${font('20_bold')}"
                >마플샵 플러스샵 신청하기</a
              >
            </div>
          </div>
        </div>
        <div class="${klass.title}">
          <h1 class="${klass.title_1280} ${font('32_bold')}">${title}</h1>
          <h1 class="${klass.title_1440} ${font('36_bold')}">${title}</h1>
          <h1 class="${klass.title_1720} ${font('48_bold')}">${title}</h1>
          <p class="${font('20_medium')}">
            굿즈제작/판매부터 크리에이터 커머스까지, 마플샵에서 수익화하세요.
          </p>
        </div>
      </section>
      <div class="parent">
        <div class="child1"></div>
        <div class="child2"></div>
      </div>
    `;
  }
}
